import { CustomCssVarsFn } from '@wix/yoshi-flow-editor';

import { DIVIDER_TYPE } from './constants';
import {
  designStylesParams,
  DesignStylesParams,
} from './Settings/Tabs/Design/stylesParams';
import {
  layoutStylesParams,
  LayoutStylesParams,
} from './Settings/Tabs/Layout/stylesParams';

export type StylesParams = DesignStylesParams & LayoutStylesParams;

export const stylesParams = {
  ...designStylesParams,
  ...layoutStylesParams,
};

export default stylesParams;

export const DIVIDER_TYPE_TO_CSS: Record<number, string> = {
  [DIVIDER_TYPE.SOLID]: 'solid',
  [DIVIDER_TYPE.DASHED]: 'dashed',
  [DIVIDER_TYPE.DOTTED]: 'dotted',
};

export const customCssVars: CustomCssVarsFn = ({ styleParams }) => {
  const dividerType = styleParams.numbers.menuDividerType ?? DIVIDER_TYPE.SOLID;

  return {
    menuDividerStyle: DIVIDER_TYPE_TO_CSS[dividerType],
  };
};
